import React from 'react';
import PropTypes from 'prop-types';

const Pause = ({ className }) => {
    return (
        <svg
            className={className}
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_dd)">
                <path
                    d="M15 32C15 18.7452 25.7452 8 39 8C52.2548 8 63 18.7452 63 32C63 45.2548 52.2548 56 39 56C25.7452 56 15 45.2548 15 32Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.001 31.9993C31.001 36.4175 34.5827 39.9993 39.001 39.9993C43.4193 39.9993 47.001 36.4175 47.001 31.9993C47.001 27.581 43.4193 23.9993 39.001 23.9993C34.5827 23.9993 31.001 27.581 31.001 31.9993ZM39.001 41.9993C33.4781 41.9993 29.001 37.5221 29.001 31.9993C29.001 26.4764 33.4781 21.9993 39.001 21.9993C44.5238 21.9993 49.001 26.4764 49.001 31.9993C49.001 37.5221 44.5238 41.9993 39.001 41.9993Z"
                    fill="#333333"
                />
                <path
                    d="M37.001 27.9993C36.4487 27.9993 36.001 28.447 36.001 28.9993L36.001 34.9993C36.001 35.5516 36.4487 35.9993 37.001 35.9993C37.5533 35.9993 38.001 35.5516 38.001 34.9993L38.001 28.9993C38.001 28.447 37.5533 27.9993 37.001 27.9993Z"
                    fill="#333333"
                />
                <path
                    d="M41.001 27.9993C40.4487 27.9993 40.001 28.447 40.001 28.9993L40.001 34.9993C40.001 35.5516 40.4487 35.9993 41.001 35.9993C41.5533 35.9993 42.001 35.5516 42.001 34.9993L42.001 28.9993C42.001 28.447 41.5533 27.9993 41.001 27.9993Z"
                    fill="#333333"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dd"
                    x="0"
                    y="0"
                    width="78"
                    height="78"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="7" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    />
                    <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

Pause.propTypes = {
    className: PropTypes.string,
};

Pause.defaultProps = {
    className: '',
};

export default Pause;
